import { Checkbox } from "@material-ui/core";
import Form from "@saleor/components/Form";
import { SubmitPromise } from "@saleor/hooks/useForm";
import React from "react";

export interface FeaturedInitialFormData {
  id: string;
  isFeatured: boolean;
}

export interface CategoryFeaturedCheckboxProps {
  id: string;
  isFeatured: boolean;
  onSubmit?: (data: FeaturedInitialFormData) => SubmitPromise;
}

const CategoryFeaturedCheckbox: React.SFC<CategoryFeaturedCheckboxProps> = props => {
  const { id, isFeatured, onSubmit } = props;

  const featuredInitialForm: FeaturedInitialFormData = {
    id,
    isFeatured
  };

  const handleOnSubmit = e => {
    // console.log(e)
    onSubmit(e);
  };
  return (
    <Form initial={featuredInitialForm} onSubmit={handleOnSubmit}>
      {({ data, change, submit }) => (
        <>
          <Checkbox
            disabled={false}
            checked={data.isFeatured}
            onChange={e => {
              change(e);
              submit();
            }}
            name="isFeatured"
            inputProps={{ "aria-label": "controlled" }}
          />
        </>
      )}
    </Form>
  );
};
CategoryFeaturedCheckbox.displayName = "CategoryFeaturedCheckbox";
export default CategoryFeaturedCheckbox;
